export default __webpack_public_path__ + "static/media/Pahalgam1.41b0043d.jpg";